export var CommitterCommand;
(function (CommitterCommand) {
    CommitterCommand["COMMITTER_COMMAND_UNSPECIFIED"] = "COMMITTER_COMMAND_UNSPECIFIED";
    CommitterCommand["COMMITTER_COMMAND_SEAL_COMPACTION"] = "SEAL_COMPACTION";
})(CommitterCommand || (CommitterCommand = {}));
